import { Col, Container } from 'react-bootstrap'
import CheckIcon from '@assets/icons/check.svg'

import Icon from '@atk/components/icon'

import styles from './RecruitmentProcess.module.scss'

export default function RecruitmentProcess() {
    const numberClass = `mb-0 me-3 fw-bold ${styles.number}`
    const lineClass = `${styles.line}`

    return (
        <section className={styles.recruitmentProcessContainer}>
            <Container>
                <Col md={8}>
                    <h2 className="mb-7">
                        Our five stage <span className="text-green">recruitment</span> process
                    </h2>
                </Col>
                <div className={styles.overflow}>
                    <div className={styles.timelineContainer}>
                        <div className="item">
                            <div className="position-relative d-flex align-items-center mb-5">
                                <p className={numberClass}>1</p>
                                <div className={lineClass}></div>
                            </div>
                            <p className="title fw-bold mb-4">Review</p>
                            <p className={styles.desc}>
                                We start by reviewing application materials in search of the best talent.
                            </p>
                        </div>
                        <div className="item">
                            <div className="position-relative d-flex align-items-center mb-5">
                                <p className={numberClass}>2</p>
                                <div className={lineClass}></div>
                            </div>
                            <p className="title fw-bold mb-4">Video/Intro call</p>
                            <p className={styles.desc}>
                                In this call, we tell you all about the company and get to know you.
                            </p>
                        </div>
                        <div className="item">
                            <div className="position-relative d-flex align-items-center mb-5">
                                <p className={numberClass}>3</p>
                                <div className={lineClass}></div>
                            </div>
                            <p className="title fw-bold mb-4">Interview</p>
                            <p className={styles.desc}>
                                Once we determine you’re a fit, you’ll have a 1-on-1 interview with your prospective
                                department and may also be asked to present your skills in a sample task.
                            </p>
                        </div>
                        <div className="item">
                            <div className="position-relative d-flex align-items-center mb-5">
                                <p className={numberClass}>4</p>
                                <div className={lineClass}></div>
                            </div>
                            <p className="title fw-bold mb-4">Offer</p>
                            <p className={styles.desc}>
                                After interviews are complete, we’ll send you a competitive offer.
                            </p>
                        </div>
                        <div className="item">
                            <div className="position-relative d-flex align-items-center mb-5">
                                <div className={numberClass}>
                                    <Icon source={CheckIcon.src} />
                                </div>
                            </div>
                            <p className="title fw-bold mb-4">Welcome!</p>
                            <p className={styles.desc}>
                                Next up is getting you ready for the employee onboarding process and answering any
                                further questions you may have.
                            </p>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}
